import { formatCurrency } from "../../utils/countryLocaleMap";

/**
 * Formats a price change value as a signed, parenthesised string.
 * Returns an empty string when the value is zero, undefined, or when
 * prices should be hidden.
 *
 * @example formatPriceChange(1.5, "GBP", "GB")       // " (+£1.50)"
 * @example formatPriceChange(-2, "GBP", "GB")        // " (-£2.00)"
 * @example formatPriceChange(0, "GBP", "GB")         // ""
 * @example formatPriceChange(1.5, "GBP", "GB", true) // ""
 */
export function formatPriceChange(
  priceChange: number | undefined,
  currency: string,
  countryCode: string,
  hidePrices = false,
): string {
  if (hidePrices || typeof priceChange !== "number" || priceChange === 0) return "";
  const sign = priceChange > 0 ? "+" : "";
  return ` (${sign}${formatCurrency(Math.abs(priceChange), currency, countryCode)})`;
}
